import React from 'react'
import { InfoCircleFilled } from '@ant-design/icons'
import { QuestionCircleFilled } from '@ant-design/icons'
import {
  DiagnosisSection as StyledDiagnosisSection,
  DiagnosisHeader,
  DiagnosisTitle,
  DiagnosisBadge,
  DiagnosisTooltip,
  DiagnosisMessage,
  DiagnosisAssessmentsGrid,
  // Use regular assessment card components for consistency
  AssessmentInfoCard,
  AssessmentInfo,
  AssessmentTitle,
  AssessmentSubtitle,
  TimeInfo,
  DaysLeft,
  DeadlineInfo,
  DeadlineLabel,
  DeadlineTime,
  TakeAssessmentButton,
  EntityTag,
  InstituteTag,
  DiagnosisAssessmentCard,
  DiagnosisAssessmentInfo,
  DiagnosisAssessmentTitle,
  DiagnosisAssessmentType,
  DiagnosisTakeButton,
} from '../../Style'

const DiagnosisSection = ({
  type,
  assessments,
  onTakeAssessment,
  diagnosisCompleted = true, // Default to enabled
}) => {

    console.log('DiagnosisSection - Type:', type)
  console.log('DiagnosisSection - All assessments:', assessments)
  console.log('DiagnosisSection - Assessment titles:', assessments.map(a => a.title))
  
  const capitalizeFirstLetter = string => {
    if (!string) return ''
    return string.charAt(0).toUpperCase() + string.slice(1)
  }

  const formatDateTime = dateTime => {
    return new Date(dateTime).toLocaleDateString('en-US', {
      month: 'short',
      day: 'numeric',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
    })
  }

  const calculateDaysLeft = endTime => {
    const now = new Date()
    const end = new Date(endTime)
    const diffTime = end - now
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24))
    return `${diffDays} days left`
  }

  // Debug logging
  console.log('DiagnosisSection - All assessments:', assessments)
  console.log('DiagnosisSection - Type:', type)
  
  let filteredAssessments = assessments.filter(assessment => {
    return assessment.is_diagnosis === true && assessment.is_one_time !== true
  })

  let numOfAptitudeDiagnosis = 0;
  let numOfCommunicationDiagnosis = 0;

  filteredAssessments.forEach((assessment) => {
    if (assessment.type === 'Aptitude') {
      numOfAptitudeDiagnosis++;
    } else if (assessment.type === 'Communication') {
      numOfCommunicationDiagnosis++;
    }
  })

    console.log('DiagnosisSection - Filtered count:', filteredAssessments.length)
  console.log('DiagnosisSection - Filtered assessments:', filteredAssessments)
  console.log('DiagnosisSection - Filtered titles:', filteredAssessments.map(a => a.title))

  filteredAssessments.forEach((assessment) => {
    assessment.AptitudeDiagnosisRemain = numOfAptitudeDiagnosis;
    assessment.CommunicationDiagnosisRemain = numOfCommunicationDiagnosis;
  })

  console.log('DiagnosisSection - Filtered assessments with diagnosis remain:', JSON.stringify(filteredAssessments, null, 2))
  return (
    <StyledDiagnosisSection>
      <DiagnosisHeader>
        <DiagnosisTitle>
          {type} Assessment
          <DiagnosisBadge>
            Diagnosis
            <QuestionCircleFilled />
            <DiagnosisTooltip className="diagnosis-tooltip">
              Diagnosis helps in understanding your current knowledge level to
              personalise further learning experience
            </DiagnosisTooltip>
          </DiagnosisBadge>
        </DiagnosisTitle>
      </DiagnosisHeader>

      <DiagnosisMessage>
        Complete these assessments to unlock next ones
      </DiagnosisMessage>

      <DiagnosisAssessmentsGrid>
        {filteredAssessments.map((assessment, index) => (
          <DiagnosisAssessmentCard key={`${assessment.id}-${index}`}>
            <DiagnosisAssessmentInfo>
              <DiagnosisAssessmentTitle>
                {capitalizeFirstLetter(assessment.title || assessment.name)}
                {!assessment.isCorporate && assessment.entityName && (
                  <InstituteTag>Institute</InstituteTag>
                )}
              </DiagnosisAssessmentTitle>
              <DiagnosisAssessmentType>
                Type: {assessment.type}
              </DiagnosisAssessmentType>
              {!assessment.isCorporate && (
                <DiagnosisAssessmentType>
                  By Institute: {assessment.entityName}
                </DiagnosisAssessmentType>
              )}
            </DiagnosisAssessmentInfo>
            <DiagnosisTakeButton
              disabled={!diagnosisCompleted}
              onClick={() => diagnosisCompleted && onTakeAssessment(assessment)}
              style={{
                opacity: diagnosisCompleted ? 1 : 0.5,
                cursor: diagnosisCompleted ? 'pointer' : 'not-allowed',
              }}
            >
              Take Assessment
            </DiagnosisTakeButton>
          </DiagnosisAssessmentCard>
        ))}
      </DiagnosisAssessmentsGrid>
    </StyledDiagnosisSection>
  )
}

export default DiagnosisSection
